import React, {createContext, useContext} from "react";
import {SortableContainer, SortableHeader, useSortContext} from "./sortContext";
import {FilterableContainer, FilterInput, useFilterContext} from "./filterContext";

const RichTableContext = createContext(null);
export const useRichTableContext = () => useContext(RichTableContext);

export function RichTableContainer({initialData, children}) {
    return <RTFilterableContainer initialData={initialData}>
        <RTSortableContainer>
            <RTChildrenContainer>
                {children}
            </RTChildrenContainer>
        </RTSortableContainer>
    </RTFilterableContainer>
}

function RTFilterableContainer({...params}) {
    return <FilterableContainer {...params} />
}

function RTSortableContainer({...params}) {
    const { data } = useFilterContext();
    return <SortableContainer {...params} initialData={data} />
}

function RTChildrenContainer({children}) {
    const { data } = useSortContext();
    const { setData, isFiltered } = useFilterContext();
    return <RichTableContext.Provider value={{ data, setData, isFiltered }}>
        {children}
    </RichTableContext.Provider>
}

export function RichTableHeader({children, sortColumn, filterColumn, sortType}) {
    return <div className={'rich-table-header'}>
        <div className={'font-height'}>
            {
                sortColumn === undefined
                    ? children
                    :
                    <SortableHeader column={sortColumn} as={sortType}>
                        {children}
                    </SortableHeader>
            }
        </div>

        {
            filterColumn === undefined
                ? null
                : <div className={'font-height mr-2'}>
                    <FilterInput column={filterColumn}/>
                </div>
        }
    </div>
}
